import {createSelector} from "@reduxjs/toolkit";
import {IPlayer} from "modules/types";
import {
	getIsAllTeamPicked,
	getIsLoadingPlayers,
	getIsLoadingSquads,
	getIsLoadingTeam,
	getIsOpenDontLoseTeamModal,
	getIsTeamHasBeenChanged,
	getPlayerByPosition,
	getPlayers,
	getTeam,
} from "modules/selectors";
import {IS_RELOAD_BLOCK_DISABLED} from "modules/constants";
import {PlayerPositionEnum} from "modules/enums";

export const getTeamPlayersIds = createSelector(getTeam, getPlayers, (team, players) => {
	const newTeam = {...team};

	Object.keys(team).forEach((key) => newTeam[key as PlayerPositionEnum]);

	return newTeam;
});

export const getIsDisabledAddToTeam = createSelector(
	getPlayerByPosition,
	getTeamPlayersIds,
	getIsAllTeamPicked,
	(getPlayerByPositionSelector, playersIds, isAllTeamPicked) => (player: IPlayer) => {
		const isPositionFilled = Boolean(getPlayerByPositionSelector(player.position));
		const isPlayerInTeam = Object.values(playersIds).includes(player.feedId);

		return isPositionFilled || isPlayerInTeam || isAllTeamPicked;
	}
);

export const getIsBlockingPicksPage = createSelector(
	getIsTeamHasBeenChanged,
	getIsOpenDontLoseTeamModal,
	getIsAllTeamPicked,
	(isTeamHasBeenChanged, isOpenDontLoseTeamModal, isAllTeamPicked) => {
		if (isOpenDontLoseTeamModal || isAllTeamPicked) {
			return false;
		}

		return isTeamHasBeenChanged && !IS_RELOAD_BLOCK_DISABLED;
	}
);

export const getIsLoadingTeamPage = createSelector(
	getIsLoadingPlayers,
	getIsLoadingSquads,
	getIsLoadingTeam,
	(isLoadingPlayers, isLoadingSquads, isLoadingTeam) => {
		return isLoadingPlayers || isLoadingSquads || isLoadingTeam;
	}
);
